import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../components/homePage.vue";
import myrentals from "../components/myRentals.vue";
import adminPage from "../components/adminPage.vue";
import singleRental from "../components/singleRental.vue";
import rentalList from "../components/rentalList.vue"
import splashScreen from "../components/splashScreen.vue";

const routes = [
  {
    path: "/",
    name: "wellcome",
    component: splashScreen,
  },
  {
    path: "/Dashboard",
    name: "home",
    component: HomeView,
  },

  {
    path: "/my-rentals",
    name: "myrental",
    component: myrentals,
  },

  {
    path: "/admin",
    name: "admin",
    component: adminPage,
  },
  {
    path: "/rental/:id",
    name: "singleRental",
    component: singleRental,
  },
  {
    path: "/rental-list",
    name: "rentalList",
    component: rentalList,
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // Always scroll to top
    return { top: 0 };
  },
});

export default router;
